
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useState, useEffect } from "react";
import { Box } from "rebass/styled-components";
import useTranslation from "next-translate/useTranslation";
import Router from "next/router";
import { StepByStepProvider, useStepByStepDispatch } from "../../components/identity/StepByStepContext";
import { trackEvent } from "../../lib/event-tracking";
import { pushRoute } from "../../lib/routing";
import { withAuth } from "../../lib/auth";
import { Step } from "../../interfaces";
import Layout from "../../components/Layout";
import StepByStep from "../../components/identity/StepByStep";
import PersonalInfo from "../../components/user/registration/PersonalInfo";
import UserDogs from "../../components/user/registration/UserDogs";
import Confirmation from "../../components/user/registration/Confirmation";
interface Props {
    query: any;
}
const RegistrationMain = ({ query }: Props) => {
    const dispatch = useStepByStepDispatch();
    const [save, setSave] = useState(false);
    const [shouldSave, setShouldSave] = useState(false);
    const [city, setCity] = useState(undefined);
    const [complete, setComplete] = useState(false);
    useEffect(() => {
        if (complete) {
            trackEvent("owner_registration_completed");
        }
    }, [complete]);
    const submitDone = (city = undefined) => {
        if (query?.redirect) {
            Router.push(query.redirect);
        }
        else {
            if (city) {
                setCity(city);
            }
            setComplete(true);
        }
    };
    const redirectToSeach = () => {
        pushRoute({
            pathname: "/search",
            search: {
                pid: city.placeId,
                lat: city.latitude,
                lng: city.longitude,
                near: city.name
            }
        });
    };
    /**
     * The following control the submissions & navigation for the current step
     */
    const submitFirstStep = () => {
        if (shouldSave) {
            setSave(true);
        }
        else {
            //moves to next step
            dispatch({
                type: "changeActive",
                payload: { active: 1 }
            });
        }
    };
    const submitLastStep = () => {
        setSave(true);
    };
    const resetTrigger = () => {
        setSave(false);
    };
    useEffect(() => {
        if (save)
            resetTrigger();
    }, [save]);
    const flow = [
        {
            step: <UserDogs reportWhenFormOpen={setShouldSave} save={save}/>,
            do: submitFirstStep
        },
        {
            step: <PersonalInfo triggerSubmit={save} submitDone={submitDone}/>,
            do: submitLastStep
        }
    ] as Step[];
    dispatch({
        type: "changeFlow",
        payload: { flow }
    });
    dispatch({
        type: "showSteps",
        payload: { showSteps: true }
    });
    return !complete ? (<Box mx="auto" pt={8} variant="layout.small">
      <StepByStep />
    </Box>) : (<Box mx="auto" pt={8} variant="layout.large">
      <Confirmation onClick={redirectToSeach}/>
    </Box>);
};
const Registration = ({ query }: Props) => {
    const { t } = useTranslation("user/registration");
    return (<Layout immersive withTransparentHeader title={t("title")}>
      <StepByStepProvider>
        <RegistrationMain query={query}/>
      </StepByStepProvider>
    </Layout>);
};
const getServerSideProps = withAuth()(async ({ query }) => {
    return { props: { query } };
});
export default Registration;

    async function __Next_Translate__getServerSideProps__1987f3f2416__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/user/registration',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1987f3f2416__ as getServerSideProps }
  